import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_ADMIN_USERS, res.data)
  })
)

export const getUser = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_ADMIN_USER, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveUser(obj).then(res => {
    commit(types.SET_ADMIN_USER, res.data.data)
    return res
  })
}

export const savePass = async ({ commit }, obj) => {
  await services.savePass(obj).then(res => {
    commit(types.SET_ADMIN_USER, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteUser = async ({ commit }, obj) => {
  await services.deleteUser(obj).then(res => {
    return res
  })
}

export const getRoles = async ({ commit }) => {
  await services.getRoles().then(res => {
    commit(types.SET_ROLES, res.data.data)
  })
}

export const getPermissions = async ({ commit }) => {
  await services.getPermissions().then(res => {
    commit(types.SET_PERMISSIONS, res.data.data)
  })
}

export const updatePermissions = async ({ commit }, { userId, permissions }) => {
  await services.updatePermissions(userId, permissions).then(res => {
    return res
  })
}

export const bulkCreate = async ({ commit }, payload) => {
  return services.bulkCreate(payload).then(res => {
    return res.data
  })
}

export const getTags = async ({ commit }) => {
  await services.getTagsForUserForm().then(res => {
    commit(types.SET_TAGS_LIST, res.data.data)
  })
}
